import React from "react";

/**
 * Keeps one broken section from taking the page with it.
 *
 * There were no error boundaries anywhere in the storefront. React unmounts the
 * whole tree when a render throws, so a single bad product row — a null title, a
 * malformed price, an image descriptor the CDN regex did not expect — turned a
 * product page or the homepage into a blank white screen. Everything below the
 * failure went with it, including the basket and the header.
 *
 * Scoped per section rather than wrapped once around the app: losing a
 * recommendation rail should cost the rail, not the buy button.
 */
export default class SectionBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // Loud in the console, silent on the page: a shopper cannot act on a stack
    // trace, and a half-rendered section is worse than an absent one.
    console.error(`[atelier] section "${this.props.name}" failed to render`, error, info);
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}
